import React from "react";

export interface ICartItem {
  id: string;
  quantity: number;
  title: string;
  image: string;
  price: string;
  content: string;
  ship: string;
}

export type CartContextType = {
  cart: ICartItem[];
  addToCart: (item: ICartItem) => void;
  updateCart: (item: ICartItem) => void;
  clearCart: () => void;
};

export const CartContext = React.createContext<CartContextType | null>(null);

const CartProvider: React.FC<React.ReactNode> = ({ children }) => {

  const [cart, setCart] = React.useState<ICartItem[]>([]);

  const addToCart = (item: ICartItem) => {
    const found = cart.find(({ id }) => id === item.id);
    if (found === undefined) {
      const newItem: ICartItem = { id: item.id, quantity: item.quantity, title: item.title,
         image: item.image, price: item.price,
        content: item.content, ship: item.ship }
      cart.push(newItem)
      setCart([...cart]);
    }
    else {
      cart.filter((i: ICartItem) => {
        if (i.id === item.id) {
          i.quantity += item.quantity;
          setCart([...cart]);
        }
        return null;
      });
    }
  };

  const updateCart = (item: ICartItem) => {
    const itemIndex = cart.findIndex(({ id }) => id === item.id);
    if (itemIndex !== -1) {
      if(item.quantity === 0)
      {
        cart.splice(itemIndex,1);
        setCart([...cart]);
      }
      else
      {
        cart[itemIndex].quantity = item.quantity;
        setCart([...cart]);
      }
    }
  }

  const clearCart = () => {
    cart.splice(0,cart.length);
    setCart([...cart]);
  }

  return (
    <CartContext.Provider value={{ cart, addToCart, updateCart, clearCart }}>
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
